import classNames from "classnames";
import { InputText } from "primereact/inputtext";
import { KeyboardEventHandler } from "react";
import { Controller, FieldValues } from "react-hook-form";

import { FormControllerProp } from "../../shared/ui/hook-form/form-controller-prop.interface";
import FormError from "../../shared/ui/hook-form/form-error/form-error";

export type InputControlType = "text" | "digit" | "password";
interface InputControlProps<FieldsType extends FieldValues>
  extends FormControllerProp<FieldsType> {
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  type?: InputControlType;
  disabled?: boolean;
  hint?: string;
  iconRight?: string;
  iconRightAction?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement> | undefined;
}

export function PreviewTextAreaControl<FieldsType extends FieldValues>({
  rules,
  label,
  control,
  name,
  placeholder,
  className,
  containerClassName,
  type,
  disabled,
  hint,
  iconRight,
  iconRightAction,
  onKeyDown,
}: InputControlProps<FieldsType>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={classNames(containerClassName)}>
          <span>
            <textarea
              className={classNames("px-1", className)}
              id={field.name}
              value={field.value}
              placeholder={placeholder}
              onChange={(e) => field.onChange(e.target.value)}
              disabled={disabled}
              onKeyDown={onKeyDown}
              rows={3}
              cols={40}
            />
          </span>
        </div>
      )}
    />
  );
}

export default PreviewTextAreaControl;
